'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import { FLOATING_ALERT_TIMING } from 'HubStyleTokens/times';
import { Children, cloneElement, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import useMounted from 'react-utils/hooks/useMounted';
import styled from 'styled-components';
const PopTransitionWrapper = styled.div.withConfig({
  displayName: "AlertListTransition__PopTransitionWrapper",
  componentId: "sc-71t57v-0"
})(["opacity:", ";transform:scale(", ");transition-property:'opacity, transform';transition-duration:", ";pointer-events:", ";"], ({
  open
}) => open ? '1' : '0', ({
  open
}) => open ? '1' : '0.9', FLOATING_ALERT_TIMING, ({
  open
}) => !open && 'none');

const renderWrappedChild = (child, open) => /*#__PURE__*/_jsx(PopTransitionWrapper, {
  className: "private-floating-alert-list__child",
  open: open,
  children: child
}, child.key);

const PopTransition = ({
  children
}) => {
  const [visibleChildren, setVisibleChildren] = useState([]);
  const [leavingChildrenKeys, setLeavingChildrenKeys] = useState({});
  const mountedRef = useMounted(); // Child add/remove logic

  useEffect(() => {
    const visibleChildrenKeys = visibleChildren.reduce((acc, visibleChild) => {
      acc[visibleChild.key] = true;
      return acc;
    }, {});
    const removedChildrenKeys = Object.assign({}, visibleChildrenKeys); // Merge our existing set of visible children with any new children

    Children.forEach(children, child => {
      const childKey = child && child.key;
      if (!childKey) return;

      if (!visibleChildrenKeys[childKey]) {
        // A new child has been added
        setVisibleChildren(prevVisibleChildren => prevVisibleChildren.concat(renderWrappedChild(child, false))); // Start "enter" animation

        requestAnimationFrame(() => {
          requestAnimationFrame(() => {
            if (!mountedRef.current) return;
            setVisibleChildren(prevVisibleChildren => prevVisibleChildren.map(c => c.key === childKey ? /*#__PURE__*/cloneElement(c, {
              open: true
            }) : c));
          });
        });
      }

      delete removedChildrenKeys[childKey];
    }); // Handle removed children

    Object.keys(removedChildrenKeys).forEach(removedKey => {
      if (leavingChildrenKeys[removedKey]) return;
      setLeavingChildrenKeys(prevLeavingChildrenKeys => Object.assign({}, prevLeavingChildrenKeys, {
        [removedKey]: true
      })); // Start "leave" animation, then remove the item completely afterward.

      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          if (!mountedRef.current) return;
          setVisibleChildren(prevVisibleChildren => prevVisibleChildren.map(c => c.key === removedKey ? /*#__PURE__*/cloneElement(c, {
            open: false
          }) : c));
          setTimeout(() => {
            if (!mountedRef.current) return;
            setVisibleChildren(prevVisibleChildren => prevVisibleChildren.filter(c => c.key !== removedKey));
            setLeavingChildrenKeys(prevLeavingChildrenKeys => Object.assign({}, prevLeavingChildrenKeys, {
              [removedKey]: false
            }));
          }, parseInt(FLOATING_ALERT_TIMING, 10));
        });
      });
    });
  }, [children]); // eslint-disable-line react-hooks/exhaustive-deps

  return visibleChildren;
};

const AlertListTransition = props => /*#__PURE__*/_jsx(PopTransition, Object.assign({}, props));

AlertListTransition.propTypes = {
  children: PropTypes.node
};
AlertListTransition.displayName = 'AlertListTransition';
export default AlertListTransition;